import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BookingPreConfirmationTemplate } from '../booking-pre-confirmation-template';
import { HttpService } from '../service/http.service';
import { PdfDocumentTemplateService } from '../pdf-document-template.service';
import { PdfTemplateViewOption } from '../pdf-template-view-option.enum';
import { ToastMessageService } from '../toast-message.service';

@Component({
  selector: 'app-booking-pre-confirmation-template-edit',
  templateUrl: './booking-pre-confirmation-template-edit.component.html',
  styleUrls: ['./booking-pre-confirmation-template-edit.component.css']
})
export class BookingPreConfirmationTemplateEditComponent implements OnInit {

  selectedTemplate!: BookingPreConfirmationTemplate;
  templateForm!: FormGroup;

  constructor(
    private httpService: HttpService,
    private builder: FormBuilder,
    private toastService: ToastMessageService,
    private pdfDocumentService: PdfDocumentTemplateService,
    private pdfDocumentTemplateService: PdfDocumentTemplateService
  ) { }

  ngOnInit(): void {
    let templateId = this.pdfDocumentService.selectedPreConfirmationTemplate.id;
    this.httpService.getBookingPreConfirmationTemplateById(templateId).subscribe(res => {
      this.selectedTemplate = res;
      this.templateForm = this.builder.group({
        beforePriceTable: this.selectedTemplate.beforePriceTable,
        afterPriceTable: this.selectedTemplate.afterPriceTable
      });
    });
  }

  backtoTheList() {
    this.pdfDocumentTemplateService.activeItemId = PdfTemplateViewOption.PRE_CONFIRMATION;
  }

  updateTemplate() {
    this.selectedTemplate.beforePriceTable = this.templateForm.value.beforePriceTable;
    this.selectedTemplate.afterPriceTable = this.templateForm.value.afterPriceTable;
    this.httpService.updateBookingPreConfirmationTemplate(this.selectedTemplate).subscribe(() => {
      this.toastService.addSuccess("Success", "template is updated");
    }, error => {
      this.toastService.addError("Error", error.message);
    });
  }
}
